module.exports = __webpack_public_path__ + "img/logo.fce37a2a.svg";